
class GetEmployeeTypesById {
 
  constructor(){
      this.searchString = undefined;
      this.searchInt = undefined;  
      this.PagingParams = {
          pageNumber : undefined,
          pageSize : undefined
      }; 
  }
}

export default GetEmployeeTypesById;

 